import { useCloseAppGuard } from '@/hooks/desktop';

/**
 * Headless desktop-only listener for the OS close request.
 *
 * Mounted once at the app root — outside auth gating — so the Rust close guard
 * always has a live handler. See `useCloseAppGuard` / `CLOSE_GUARD_READY`.
 */
export const TauriCloseGuard = () => {
  useCloseAppGuard();
  return null;
};
